import eliminateNotEliminateSubtitleMessages from './eliminateNotEliminateSubtitleMessages'
import eliminateNotEliminateTexts from './eliminateNotEliminateTexts'
import filterUnnecessary from './filterUnnecessary'
import finalityCheck from './finalityCheck'
import getContinuedText from './getContinuedText'
import getFinalizedText from './getFinalizedText'
import getFragilityActionText from './getFragilityActionText'
import getResponsableNames from './getResponsableNames'
import origin from './origin'
import reavaliatedAllData from './reavaliatedAllData'
import status from './status'
import statusChipColor from './statusChipColor'
import statusesCheck from './statusesCheck'
import stepChipColor from './stepChipColor'
import typeChipColor from './typeChipColor'

export default {
  eliminateNotEliminateSubtitleMessages,
  eliminateNotEliminateTexts,
  filterUnnecessary,
  finalityCheck,
  getContinuedText,
  getFinalizedText,
  getFragilityActionText,
  getResponsableNames,
  origin,
  reavaliatedAllData,
  status,
  statusChipColor,
  statusesCheck,
  stepChipColor,
  typeChipColor,
}
